webpackJsonp([26],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(9);
	__webpack_require__(20);
	__webpack_require__(8);
	__webpack_require__(17);
	__webpack_require__(18);
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(119);
	
	__webpack_require__(1);
	__webpack_require__(5);
	__webpack_require__(14);
	__webpack_require__(7);
	__webpack_require__(6);
	__webpack_require__(4);
	__webpack_require__(15);
	__webpack_require__(11);
	__webpack_require__(2);
	__webpack_require__(26);
	
	// 表单
	$(function() {
	  "use strict";
	
	  var $forms = $("main form");
	  $forms.each(function(inde, form) {
	    var $form = $(form);
	
	    $form.validate({
	      errorPlacement: function(error) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: false
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber + "}";
	
	        $(form).ajaxSubmit({
	          dataType: "json",
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + new Date().getTime()
	          },
	          error: function() {
	            return swal({
	              title: "对不起，出错了，请稍后重试！",
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            if (res.msg && res.msg[0] && res.msg[0].type === "success") {
	              swal({
	                type: "success",
	                title: '预约成功，稍后会有家装顾问与您联系，请注意电话',
	                allowOutsideClick: true
	              });
	              // swal({
	              //   customClass: "alert-success",
	              //   title:
	              //     '<img class="form_success" src="' +
	              //     $("#alertImg").attr("src") +
	              //     '" alt="">',
	              //   confirmButtonText: "返  回",
	              //   confirmButtonColor: "#3b9bff",
	              //   allowOutsideClick: true,
	              //   html: true
	              // });
	            }
	            if (res.msg[0].type === "error") {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	            if (res.msg[0].type === "error") {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	      }
	    });
	
	    var elements = form.elements;
	    // var effectives = [];
	
	    for (var i = 0; i < elements.length; i++) {
	      var element = elements[i];
	      var name = $(element).attr("name");
	      if (name) {
	        // effectives.push(element);
	        var $elm = $(element);
	        $elm.rules("add", {
	          // required: Boolean($elm.attr('required')),
	          mobileNum: Boolean($elm.attr("mobile")),
	          messages: {
	            required: $elm.data("required"),
	            mobileNum: $elm.data("mobile")
	          }
	        });
	      }
	    }
	  });
	});
	
	
	"use strict";
	$('#configure-tabs li').click(function() {
	  "use strict";
	  $('#configure-items>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	});
	
	$('#space-tabs li').click(function() {
	  "use strict";
	  $('#space-items>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	});
	
	$('#newHouse-tab li').click(function() {
	  "use strict";
	  $('#newHouse-cont>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	});
	
	$('#meal-tab li').click(function() {
	  "use strict";
	  $('#meal-cont>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	});
	
	$('#style-tab li').click(function() {
	  "use strict";
	  $('#style-cont>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	});
	
	$('#tab-ul-bank li').click(function() {
	  "use strict";
	  $('#tab-ul-bank-cont>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	});
	
	$('.right-tabs ul li').click(function(e) {
	  "use strict";
	  var $this = $(this);
	  var $target = $(e.target);
	  var $leftCont = $target.parents('.right-tabs').parent().children('.left-cont');
	  $leftCont.children('.left-item').eq($this.index()).addClass('show').siblings().removeClass('show');
	  $this.addClass('active').siblings().removeClass('active'); 
	});
	
	var mainSwiper = new Swiper('.content .swiper-container-vertical',{
	  pagination: '.swiper-pagination-vertical',
	  paginationType: 'custom',//自定义-分页器样式类型（前提）
	  direction: 'vertical',
	  slidesPerView: 1,
	  paginationClickable: true,
	  autoplayDisableOnInteraction: false,
	  simulateTouch: false,
	  mousewheelControl: true,
	  paginationCustomRender: function (swiper, current, total) {
	    "use strict";
	    var _html = '';
	    var t = "";
	    for (var i = 1; i <= total; i++) {
	      if(i === 1) {
	        t = "";
	      } else if(i === 2) {
	        t = "01 产品套餐";
	      } else if(i === 3) {
	        t = "02 颜值效果";
	      } else if(i === 4) {
	        t = "03 十大空间";
	      } else if(i === 5) {
	        t = "04 严选材料";
	      } else if(i === 6) {
	        t = "05 施工交付";
	      } else if(i === 7) {
	        t = "06 装修服务";
	      } else if(i === 8) {
	        t = "07 配置新家";
	      } else if(i === 9) {
	        t = "08 线下体验店";
	      } else if(i === 10) {
	        t = "09 更多服务";
	      }
	      if(current === i) {
	        _html += '<li class="swiper-pagination-custom active">' + t + '</li>';
	      } else {
	        _html += '<li class="swiper-pagination-custom">' + t  + '</li>';
	      }
	    }
	    return _html;//返回所有的页码html
	  },
	  onInit: function(swiper) {
	    "use strict";
	    swiper.activeIndex ? $('.swiper-pagination-vertical').removeClass('hide') : $('.swiper-pagination-vertical').addClass('hide');
	  },
	  onSlideChangeStart: function(swiper) {
	    "use strict";
	    ![0, 10].includes(swiper.activeIndex) ? $('.swiper-pagination-vertical').removeClass('hide') : $('.swiper-pagination-vertical').addClass('hide');
	  }
	});
	// mainSwiper.slideTo(7)
	
	new Swiper('#configure .swiper-container',{
	  pagination : '.video-swiper-pagination',
	  autoplayDisableOnInteraction: false,
	  paginationClickable: true,
	  loop: true,
	  autoplay: 1500
	});
	
	new Swiper('.old-house-swiper .swiper-container',{
	  pagination : '.video-swiper-pagination',
	  paginationClickable: true,
	  loop: true,
	  autoplay: 2000,
	  effect : 'fade',
	  fade: {
	    crossFade: true,
	  }
	});
	
	$('.swiper-pagination-vertical').click(function(e) {
	  "use strict";
	  var $paginations = $(e.currentTarget).find('.swiper-pagination-custom');
	  var index = $paginations.index(e.target);
	  mainSwiper.slideTo(index);
	});
	
	var setSwiperGallery = function(topEl, thumbsEl) {
	  "use strict";
	  var galleryTop = new Swiper(topEl, {
	    autoplayDisableOnInteraction: false,
	    paginationClickable: true,
	    autoplay: 2000
	  });
	  
	  var galleryThumbs = new Swiper(thumbsEl, {
	    autoplayDisableOnInteraction: false,
	    centeredSlides: true,
	    touchRatio: 0.2,
	    slidesPerView: 4,
	    slideToClickedSlide: true
	  });
	
	  galleryTop.params.control = galleryThumbs;
	  galleryThumbs.params.control = galleryTop;
	};
	
	var $topEls = $('#space-items .left-item-swiper-container');
	var $thumbsEls = $('#space-items .gallery-thumbs');
	
	$topEls.each(function(index) {
	  "use strict";
	  setSwiperGallery($topEls[index], $thumbsEls[index]);
	});
	
	new Swiper('#deliver .swiper-container-deliver',{
	  prevButton:'.swiper-button-prev-deliver',
	  nextButton:'.swiper-button-next-deliver',
	  effect : 'fade',
	  fade: {
	    crossFade: true,
	  }
	});
	
	new Swiper('#quality .swiper-container-deliver',{
	  prevButton:'.swiper-button-prev-deliver',
	  nextButton:'.swiper-button-next-deliver',
	  effect: 'fade',
	  loop: true,
	  autoplay: 1500,
	  fade: {
	    crossFade: true,
	  }
	});
	
	$('#next-btn').click(function() {
	  "use strict";
	  var inputVaule = $('.right-input').val();
	  var styleChecked = $('.style-checked').text();
	
	  if(!styleChecked) {
	    swal({
	      title: "请选择您喜欢的装修风格!",
	      allowOutsideClick: true
	    });
	  } else if(!inputVaule) {
	    swal({
	      title: "请输入您家面积！",
	      allowOutsideClick: true
	    });
	  } else {
	    $('.plan-from').show();
	    $('.newHouse').hide();
	    $('.house-title').hide();
	  }
	});
	
	$('#prev-btn').click(function() {
	  "use strict";
	  $('.plan-from').hide();
	  $('.newHouse').show();
	  $('.house-title').show();
	});
	
	// 套餐选择
	var mealTabValue = $('#meal-tab .active').text();
	$('.meal-checked').text(mealTabValue);
	
	// 面积
	var retailPriceAll = function() {
	  "use strict";
	  var mealChecked = $('.from-meal-checked').text();
	  var retailPrice = 0;
	  if(mealChecked === '精装699') {
	    retailPrice = 699 * Number($(".right-input").val());
	    $('.retail-price').text(retailPrice);
	    $('.style-number').text('699');
	    $('.style-text').text('精装舒适型');
	  } else if(mealChecked === '整装1099') {
	    retailPrice = 1099 * Number($(".right-input").val());
	    $('.retail-price').text(retailPrice);
	    $('.style-number').text('1099');
	    $('.style-text').text('整装拎包入住型');
	  } else if(mealChecked === '精装房') {
	    retailPrice = 399 * Number($(".right-input").val());
	    $('.retail-price').text(retailPrice);
	    $('.style-number').text('399');
	    $('.style-text').text('精装房拎包入住型');
	  } else {
	    $('.retail-price').text(retailPrice);
	  }
	};
	retailPriceAll();
	
	var fullPaymentValue = function() {
	  "use strict";
	  var mealChecked = $('.full-payment-meal').text();
	  var retailPrice = 0;
	  if(mealChecked === '精装699') {
	    retailPrice = 699 * Number($(".right-input").val());
	    $('.full-payment').text(retailPrice);
	    $('#full-payment').text(retailPrice);
	  } else if(mealChecked === '整装1099') {
	    retailPrice = 1099 * Number($(".right-input").val());
	    $('.full-payment').text(retailPrice);
	    $('#full-payment').text(retailPrice);
	  } else if(mealChecked === '精装房') {
	    retailPrice = 399 * Number($(".right-input").val());
	    $('.full-payment').text(retailPrice);
	    $('#full-payment').text(retailPrice);
	  } else {
	    $('.full-payment').text(retailPrice);
	    $('#full-payment').text(retailPrice);
	  }
	};
	fullPaymentValue();
	
	//套餐价格
	var fromPackagePriceAll = function() {
	  "use strict";
	  var fromPackagePrice = 0;
	  fromPackagePrice = Number(Number($('.retail-price').text()) + Number($('.interest-show span').text())).toFixed(2);
	  $('.from-package-price span').text(fromPackagePrice);
	  $('.all-package-price span').text(fromPackagePrice);
	};
	fromPackagePriceAll();
	
	
	// 预估首付
	var trafficBankValue = function(scale) {
	  "use strict";
	  var scaleValue = scale ? (Number(scale) / 100) : 0.15;
	  var trafficBank = (Number($('.retail-price').text()) * scaleValue).toFixed(2);
	  $('#down-payment').text(trafficBank);
	
	  var trafficBank2 = (Number($('.retail-price').text()) * scaleValue).toFixed(2);
	  $('#down-payment2').text(trafficBank2);
	
	  var trafficBank3 = (Number($('.retail-price').text()) * scaleValue).toFixed(2);
	  $('#down-payment3').text(trafficBank3);
	};
	trafficBankValue();
	
	//贷款/融资金融
	var loanValue = function(scale) {
	  "use strict";
	  var scaleValue = scale ? (Number(scale) / 100) : 0.15;
	  var loan = (Number($('.retail-price').text()) * (1 - scaleValue)).toFixed(2);
	  $('#loan').text(loan);
	
	  var loan2 = (Number($('.retail-price').text()) * (1 - scaleValue)).toFixed(2);
	  $('#loan2').text(loan2);
	
	  var loan3 = (Number($('.retail-price').text()) * (1 - scaleValue)).toFixed(2);
	  $('#loan3').text(loan3);
	};
	loanValue();
	
	//总利息
	var totalInterestValue = function() {
	  "use strict";
	  var totalInterest = ((Number($('#loan').text()) * Number($('#interest-rate').text()) * Number($('#number-periods').text())) / 1200).toFixed(2);
	  $('#totalInterest').text(totalInterest);
	
	  var totalInterest2 = ((Number($('#loan2').text()) * Number($('#interest-rate2').text()) * Number($('#number-periods2').text())) / 1200).toFixed(2);
	  $('#totalInterest2').text(totalInterest2);
	
	  var totalInterest3 = ((Number($('#loan3').text()) * Number($('#interest-rate3').text()) * Number($('#number-periods3').text())) / 1200).toFixed(2);
	  $('#totalInterest3').text(totalInterest3);
	};
	totalInterestValue();
	
	//老---总利息
	var totalInterestOldValue = function() {
	  "use strict";
	  var totalInterestOld = ((Number($('#loan').text()) * Number($('#interest-rate-old').text()) * Number($('#number-periods').text())) / 1200).toFixed(2);
	  $('#totalInterest-old').text(totalInterestOld);
	
	  var totalInterestOld2 = ((Number($('#loan2').text()) * Number($('#interest-rate-old2').text()) * Number($('#number-periods2').text())) / 1200).toFixed(2);
	  $('#totalInterest-old2').text(totalInterestOld2);
	
	  var totalInterestOld3 = ((Number($('#loan3').text()) * Number($('#interest-rate-old3').text()) * Number($('#number-periods3').text())) / 1200).toFixed(2);
	  $('#totalInterest-old3').text(totalInterestOld3);
	};
	totalInterestOldValue();
	
	//表单总利息
	var interestCheckValue = function() {
	  "use strict";
	  var interestCheck = $('#tab-ul-bank-cont .show .interest-checked span').text();
	  $('.interest-show span').text(interestCheck);
	};
	interestCheckValue();
	
	//预估月供
	var monthlyValue = function() {
	  "use strict";
	  var monthly = ((Number($('#loan').text()) + Number($('#totalInterest').text())) / Number($('#number-periods').text())).toFixed(2);
	  $('#monthly').text(monthly);
	
	  var monthly2 = ((Number($('#loan2').text()) + Number($('#totalInterest2').text())) / Number($('#number-periods2').text())).toFixed(2);
	  $('#monthly2').text(monthly2);
	
	  var monthly3 = ((Number($('#loan3').text()) + Number($('#totalInterest3').text())) / Number($('#number-periods3').text())).toFixed(2);
	  $('#monthly3').text(monthly3);
	};
	monthlyValue();
	
	// 套餐选择
	$('#meal-tab li').click(function(e) {
	  "use strict";
	  if(e.currentTarget.innerText === '旧房改造') {
	    $('#next-btn').hide();
	    $('#input-area').hide();
	  } else {
	    $('#next-btn').show();
	    $('#input-area').show();
	  }
	  $('.meal-checked').text(e.currentTarget.innerText);
	  retailPriceAll();
	  fullPaymentValue();
	  trafficBankValue();
	  loanValue();
	  totalInterestValue();
	  totalInterestOldValue();
	  interestCheckValue();
	  fromPackagePriceAll();
	  monthlyValue();
	});
	
	// 风格样式
	var styleTabValue = $('#style-tab .active').text();
	$('.style-checked').text(styleTabValue);
	var styleContImg = $('#style-cont .show img')[0].src;
	$('.area-img').attr('src',styleContImg);
	
	$('#style-tab li').click(function(e) {
	  "use strict";
	  $('.style-checked').text(e.currentTarget.innerText);
	  var styleContImg = $('#style-cont .show img')[0].src;
	  $('.area-img').attr('src',styleContImg);
	});
	
	// 面积
	$(".right-input").on("input", function () {
	  "use strict";
	  $(".input-value .number").text($(this).val());
	  retailPriceAll();
	  fullPaymentValue();
	  trafficBankValue();
	  loanValue();
	  totalInterestValue();
	  totalInterestOldValue();
	  interestCheckValue();
	  fromPackagePriceAll();
	  monthlyValue();
	});
	
	// 总利息
	$('#tab-ul-bank li').click(function() {
	  "use strict";
	  var interestCheck = $('#tab-ul-bank-cont .show .interest-checked span').text();
	  $('.interest-show span').text(interestCheck);
	  fromPackagePriceAll();
	});
	
	// 交通银行--期数
	var numberPeriods = $('#traffic-bank .tab-ul .active span').text();
	$('#number-periods').text(numberPeriods);
	$('#traffic-bank .tab-ul li').click(function(e) {
	  "use strict";
	  $(this).addClass('active').siblings().removeClass('active'); 
	  $('#number-periods').text(e.currentTarget.children[0].outerText);
	  totalInterestValue();
	  totalInterestOldValue();
	  interestCheckValue();
	  fromPackagePriceAll();
	  monthlyValue();
	});
	
	// 建设银行--期数
	var numberPeriods2 = $('#build-bank .tab-ul .active span').text();
	$('#number-periods2').text(numberPeriods2);
	$('#build-bank .tab-ul li').click(function(e) {
	  "use strict";
	  $(this).addClass('active').siblings().removeClass('active'); 
	  $('#number-periods2').text(e.currentTarget.children[0].outerText);
	  totalInterestValue();
	  totalInterestOldValue();
	  interestCheckValue();
	  fromPackagePriceAll();
	  monthlyValue();
	});
	
	//浦发银行--期数
	var numberPeriods3 = $('#SPD-bank .tab-ul .active span').text();
	$('#number-periods3').text(numberPeriods3);
	$('#SPD-bank .tab-ul li').click(function(e) {
	  "use strict";
	  $(this).addClass('active').siblings().removeClass('active'); 
	  $('#number-periods3').text(e.currentTarget.children[0].outerText);
	  totalInterestValue();
	  totalInterestOldValue();
	  interestCheckValue();
	  fromPackagePriceAll();
	  monthlyValue();
	});
	var Progress = function(
	  option
	) {
	  "use strict";
	  this.option = option || {
	    el: '',
	    bar: '',
	    barInner: '',
	    handler: '',
	    valueEl: '',
	    start: 0,
	    end: 100,
	    step: 5,
	    isStep: false,
	    on: {}
	  };
	
	  this.init(this.option);
	};
	
	Progress.prototype.init = function(option) {
	  "use strict";
	  this.$el = $(option.el); // 容器元素
	  this.$el = $(option.el); // 容器元素
	  this.$bar = $(option.bar); // 条元素
	  this.$barInner = $(option.barInner); // 内部进度条元素
	  this.$handler = $(option.handler); // 控制元素
	  this.$valueEl = $(option.valueEl); // 数值显示元素
	  this.inControl = false; // 是否在控制中
	  this.handlerLeft = this.$handler.position().left;
	  this.$on = $(option.on);
	
	  this.initEvent();
	  this.setHandlerPosition();
	};
	
	Progress.prototype.initEvent = function() {
	  "use strict";
	  var _this = this;
	  this.$handler.mousedown(function(e) {
	    _this.handleMouseDown(e);
	    _this.inControl = true;
	  });
	  $(document).mousemove(function(e) {
	    if (!_this.inControl) { return; } // 如果不在控制中，mousemove事件不触发具体方法
	    _this.handleMouseMove(e);
	  });
	  $(document).mouseup(function() {
	    _this.inControl = false;
	  });
	};
	
	Progress.prototype.handleMouseDown = function(e) {
	  "use strict";
	  this.handlerLeft = this.$handler.position().left;
	  this.pointerPosition = {
	    left: e.pageX
	  };
	};
	
	Progress.prototype.setHandlerPosition = function(left) {
	  "use strict";
	  left = left + this.handlerLeft;
	  var barWidth = this.$bar.width();
	  if (left < 0 || left > barWidth) {
	    return;
	  }
	  this.$handler.css({
	    left: left
	  });
	  var percent = (left | 0) / barWidth;
	  const value = this.getValueByPercent(percent);
	  this.setValue(value);
	};
	
	Progress.prototype.getValueByPercent = function(percent) {
	  "use strict";
	  var start = this.option.start;
	  var end = this.option.end;
	  var rangeLength = end - start;
	  var valueOffset = percent * rangeLength;
	  return parseInt(valueOffset + start);
	};
	
	Progress.prototype.setValue = function(value) {
	  "use strict";
	  if (this.option.on.change && typeof this.option.on.change === 'function') {
	    this.option.on.change(value);
	  }
	  this.$valueEl.html(parseInt(value) + '%');
	};
	
	Progress.prototype.handleMouseMove = function(e) {
	  "use strict";
	  var originPointerLeft = this.pointerPosition.left;
	  var leftOffset = e.pageX - originPointerLeft;
	  this.setHandlerPosition(leftOffset);
	};
	
	// 实例销毁
	// Progress.prototype.destroy = function() {
	 
	// }
	
	new Progress({
	  el: '.progress',
	  bar: '.scroll',
	  barInner: '.mask',
	  handler: '.bar',
	  valueEl: '.progress-text',
	  start: 15,
	  end: 80,
	  step: 5,
	  isStep: false,
	  on: {
	    change: function(value) {
	      "use strict";
	      trafficBankValue(parseInt(value));
	      loanValue(parseInt(value));
	      totalInterestValue();
	      totalInterestOldValue();
	      interestCheckValue();
	      fromPackagePriceAll();
	      monthlyValue();
	    }
	  }
	});
	
	$('.plan-radio li').click(function() {
	  "use strict";
	  $('.plan-cont>div').eq($(this).index()).addClass('show').siblings().removeClass('show');
	  $(this).addClass('active').siblings().removeClass('active'); 
	  if($(this)[0].innerText === '全款') {
	    $('.all-package-price span').text($('#full-payment').text());
	  } else {
	    $('.all-package-price span').text($('.from-package-price span').text());
	  }
	});
	
	// if(window.innerWidth < 1680) {
	//   $('.product-page').removeClass('resize-box');
	//   $('.swiper-pagination-vertical').hide();
	// }
	
	// var resize = function() {
	//   "use strict";
	//   if(window.innerWidth < 1680) {
	//     $('.product-page').removeClass('resize-box');
	//     $('.swiper-pagination-vertical').hide();
	//   } else {
	//     $('.product-page').addClass('resize-box');
	//     $('.swiper-pagination-vertical').show();
	//   }
	// };
	// window.onresize = resize;
	


/***/ },

/***/ 119:
3

});


/** WEBPACK FOOTER **
 ** new-house-count.36e2718c6691c05d27d7.js
 **/